import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'src/app/modules/local-storage/local-storage.module';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenderService {
  visibility: BehaviorSubject<boolean>;

  constructor(private http: HttpClient, private localStorageService: LocalStorageService ) { }

  public getTender(id: number) {
    return this.http.get(`${environment.resource_api}carts/${id}`,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }
}
